import { useContext, useEffect, useState } from "react";
import Avatar from "../../components/Avatar";
import { AuthContext } from "../../contexts/AuthContext";
import Fuse from "fuse.js";
import RoleDropdown from "./Organization/RoleDropdown";
import { TeamContext } from "../../contexts/TeamContext";
import { MagnifyingGlassIcon } from "@heroicons/react/24/solid";
export default function UserList({ users }) {
  const { supabase, session } = useContext(AuthContext);
  const [fuseSearchObject, setFuseSearchObject] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [fuseResults, setFuseResults] = useState([]);
  const { team } = useContext(TeamContext);

  // Whenever people updates, update fusejs object
  useEffect(() => {
    const fuse = new Fuse(users || {}, {
      keys: [
        "email", // will be assigned a `weight` of 1
        "username",
      ],
    });
    setFuseSearchObject(fuse);
  }, [users]);

  const search = (e) => {
    e.preventDefault();
    const query = e.target.value;
    setSearchQuery(query);
    const results = fuseSearchObject.search(query);
    setFuseResults(results.map((r) => r.item));
  };

  const hasSearchResults = searchQuery?.length > 0 && fuseResults?.length > 0;

  // Determine if a "No users found" message should be displayed
  const showNoUsersFoundMessage =
    searchQuery?.length > 0 && fuseResults?.length == 0;

  // Determine the list to display: either the search results or the full list of people
  const listToDisplay = hasSearchResults ? fuseResults : users;

  return (
    <ul role="list" className="">
      <div className="flex w-full border rounded-lg mb-2 px-2 items-center space-x-2">
        <MagnifyingGlassIcon className="text-gray-400 w-4" />
        <input
          onChange={(e) => search(e)}
          type="text"
          placeholder="Type to filter users"
          className="w-full border-none text-xs px-0 focus:ring-0"
        />
      </div>

      <>
        {showNoUsersFoundMessage && (
          <p className="text-xs text-gray-500 py-4">No users found</p>
        )}
        {!showNoUsersFoundMessage &&
          listToDisplay?.map((person) => (
            <li
              key={person.email}
              className="flex justify-between border-b border-gray-100 gap-x-6 py-3"
            >
              <div className="flex min-w-0 gap-x-4">
                <Avatar
                  image={person.avatar}
                  name={person.username}
                  email={person.email}
                />
                <div className="min-w-0 flex-auto -mt-1">
                  <p className="text-sm mb-0 p-0 font-semibold leading-6 text-gray-900">
                    {person.username}
                  </p>
                  <p className="truncate text-xs -mt-1 leading-5 text-gray-500">
                    {person.email}
                  </p>
                </div>
              </div>
              <div className="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                <div>
                  <RoleDropdown
                    uid={person.id}
                    role={person.role?.relationship?.relation}
                    orgId={team}
                  />
                </div>
              </div>
            </li>
          ))}
      </>
    </ul>
  );
}
